module.exports = __webpack_public_path__ + "img/sld_mfm_inv_4_t1_b1_dark.11160f6e.svg";